import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useNavigate } from "react-router";
import { SlDrawer, SlInput, SlIcon } from "@shoelace-style/shoelace/dist/react";
import { useFormik } from "formik";
import api from "../../services/api";
import { formatDateWithTime } from "../../utils/dateFormat";
import NoDataFound from "../../shared/NoDataFound";
import { Toast } from "../../shared/Toast";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import TableLoader from "../../shared/TableLoader";
import { useSelector } from "react-redux";
import { ScrollContainer } from "react-indiana-drag-scroll";
import { debounce } from "../../utils/Debounce";
import { SlTooltip, SlIconButton, SlButton } from "@shoelace-style/shoelace/dist/react";
import { roles, langoptions, NewspaperDistrictEditonAdformats, NewspaperMainEditonAdformats, NewspaperOptions } from "../../utils/constants";
import Select from "react-select";

const initialPageRates = {
  newspaper_name: "",
  page_name: "",
  // page_no: '',
  ad_format: "",
  language: "",
  estimated_value: "",
};
let initialValues = JSON.parse(JSON.stringify(initialPageRates));

const PageRateSchema = Yup.object().shape({
  newspaper_name: Yup.string().required("Newspaper Name is required"),
  page_name: Yup.string().required("Page Name is required"),
  // page_no: Yup.string().required('Page Number is required'),
  ad_format: Yup.string().required("Ad Format Name is required"),
  language: Yup.string().required("Language is required"),
  estimated_value: Yup.string().required("Estimated Value  is required"),
});

function Pagerates() {
  const navigate = useNavigate();

  const pageOptions = [
    { value: "Main_Edition", label: "Main Edition" },
    { value: "District_Edition", label: "District Edition" },
  ];

  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [flag, setFlag] = useState("");
  const [id, setId] = useState("");
  const [search, setSearch] = useState("");
  const [editions, setEditions] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [newspapers, setNewspapers] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [clusterOptions, setClusterOptions] = useState([]);
  const [selectedCluster, setSelectedCluster] = useState(null);
  const [clusterLoading, setClusterLoading] = useState(false);
  const [showAddDistrict, setShowAddDistrict] = useState(false);
  const [newDistrict, setNewDistrict] = useState("");
  const [showAddCluster, setShowAddCluster] = useState(false);
  const [newCluster, setNewCluster] = useState("");

  const getLanguageNameByCode = (language) => {
    const lang = langoptions.find((option) => option.value === language);
    return lang ? lang.label : "Unknown";
  };
  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    loadData(search, event.selected);
  };
  const HeaderSearch = useSelector((state) => state.Head.adssearch);

  const handleClose = () => {
    setShow(false);
    setSubmit(false);
    initialValues = JSON.parse(JSON.stringify(initialPageRates));
    formik.setValues(initialValues);
  };

  const handleShow = (choose, item) => {
    if (choose === "add") {
      formik.setValues({
        ...initialPageRates,
        language: 1, // Telugu
        newspaper_name: "Eenadu", // Enaadu
      });
      setSelectedDistricts([]);
      setSelectedCluster(null);
      setShow(true);
    }
    if (choose === "edit") {
      setFlag("edit");
      setId(item.rate_id);
      formik.setValues({
        page_name: item.page_name,
        newspaper_name: item.newspaper_name,
        ad_format: item.ad_format,
        language: item.language,
        estimated_value: item.estimated_value,
        district: item.district,
        cluster: item.cluster,
      });
      setSelectedDistricts([]); // reset — will be filled later after districtOptions load
      setSelectedCluster(null);
      setShow(true);
    }
  };

  const loadData = async (searchString = "", page = 0) => {
    try {
      setLoader(true);
      let res = await api({
        url: `/birdview/get_page_rates`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          search: searchString,
        },
      });
      setData(res.data.data.length ? res.data.data : []);
      setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (error.response.status === 401) navigate("/");
    }
  };

  const Header = () => {
    setSearch(HeaderSearch);
    setCurrentPage(0);
    loadData(HeaderSearch, 0);
  };

  const searchData = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
    loadData(e.target.value, 0);
  };
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  let formik = useFormik({
    initialValues: JSON.parse(JSON.stringify(initialPageRates)),
    validationSchema: PageRateSchema,
    onSubmit: async (values) => {
      // Add location and cluster to values if district edition
      if (isDistrict) {
        values.location = selectedDistricts.length ? selectedDistricts.map((d) => d.label) : null;
        values.cluster = selectedDistricts.length === 1 && selectedCluster ? selectedCluster.label : null;
      } else {
        values.location = null;
        values.cluster = null;
      }
      if (flag === "add") {
        try {
          let res = await api({
            url: `/birdview/add_page_rate`,
            method: "POST",
            responseType: "json",
            data: values,
          });
          if (res?.data?.code === 500) {
            Toast("error", res.data.message);
          } else {
            Toast("success", "Page Rate Added Successfully");
            handleClose();
            setCurrentPage(0);
            setSearch("");
            loadData(search, 0);
          }
        } catch (error) {
          let er = error?.response?.message || "Something went wrong";
          Toast("error", er);
          if (error.response.status === 401) navigate("/");
        }
      }
      if (flag === "edit") {
        try {
          let res = await api({
            url: `/birdview/edit_page_rate/${id}`,
            method: "PUT",
            responseType: "json",
            data: values,
          });
          if (res?.data?.code === 500) {
            Toast("error", res.data.message);
          } else {
            Toast("success", "Page updated Successfully");
            handleClose();
            loadData(search, currentPage);
            values.page_name = "";
            values.newspaper_name = "";
            // values.page_no = ''
            values.estimated_value = "";
            values.ad_format = "";
            values.language = "";
          }
        } catch (error) {
          let er = error?.response?.message || "Something went wrong";
          Toast("error", er);
          if (error.response.status === 401) navigate("/");
        }
      }
    },
  });

  const pageNameLower = formik.values.page_name ? formik.values.page_name.toLowerCase() : "";
  const isMain = pageNameLower.includes("main");
  const isDistrict = pageNameLower.includes("district");
  const AdFormatOptions = isMain ? NewspaperMainEditonAdformats : isDistrict ? NewspaperDistrictEditonAdformats : [];

  const loadEditions = async (language) => {
    if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
      const response = await api({
        url: `/birdview/newspaper_editions`,
        method: "POST",
        responseType: "json",
        data: { lang_id: language },
      });
      if (response?.code === 200) {
        setEditions(response?.data?.result);
      } else {
        toast.error(response?.data?.message);
      }
    }
  };

  useEffect(() => {
    if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
      loadEditions(formik.values.language);
    }
  }, [formik.values.language]);

  useEffect(() => {
    Header();
  }, [HeaderSearch]);

  useEffect(() => {
    const fetchNewspapers = async () => {
      const options = await NewspaperOptions();
      setNewspapers(options);
    };

    fetchNewspapers();
  }, []);

  // Fetch districts when language or edition changes
  useEffect(() => {
    async function fetchDistricts() {
      if (isDistrict && formik.values.language && formik.values.page_name) {
        const response = await api({
          url: "/birdview/newspaper_locations",
          method: "POST",
          responseType: "json",
          data: { lang_id: formik.values.language, edition: formik.values.page_name },
        });
        if (response?.code === 200 && Array.isArray(response.data.result)) {
          setDistrictOptions(response.data.result);
        } else {
          setDistrictOptions([]);
        }
      } else {
        setDistrictOptions([]);
      }
      setSelectedDistricts([]);
      setSelectedCluster(null);
    }
    fetchDistricts();
  }, [formik.values.language, formik.values.page_name, isDistrict]);

  // Prefill selectedDistricts and selectedCluster after districtOptions are loaded (edit mode)
  useEffect(() => {
    if (!isDistrict || !formik.values.page_name || !formik.values.language || !districtOptions.length) return;

    if (flag === "edit" && formik.values.page_name.toLowerCase().includes("district")) {
      let districts = [];
      if (typeof formik.values.district === "string") {
        districts = formik.values.district.split("+").map((s) => s.trim());
      } else if (Array.isArray(formik.values.district)) {
        districts = formik.values.district;
      }
      const prefillDistricts = districtOptions.filter((opt) => districts.includes(opt.label));
      setSelectedDistricts(prefillDistricts);
    }
  }, [districtOptions, isDistrict, formik.values.page_name, flag]);

  // Fetch clusters when only 1 district is selected
  useEffect(() => {
    async function fetchClusters() {
      if (isDistrict && selectedDistricts.length === 1) {
        setClusterLoading(true);
        const response = await api({
          url: "/birdview/getClusters",
          method: "POST",
          responseType: "json",
          data: { district: selectedDistricts[0].label },
        });
        if (response?.code === 200 && Array.isArray(response.data?.clusters)) {
          const clusterOpts = response.data?.clusters.map((c) => ({ label: c, value: c }));
          setClusterOptions(clusterOpts);
          if (flag === "edit" && formik.values.cluster) {
            const match = clusterOpts.find((opt) => opt.label === formik.values.cluster);
            setSelectedCluster(match || null);
          }
        } else {
          setClusterOptions([]);
        }
        setClusterLoading(false);
      } else {
        setClusterOptions([]);
        setSelectedCluster(null);
      }
    }
    fetchClusters();
  }, [selectedDistricts, isDistrict, flag, formik.values.cluster]);

  return (
    <>
      <div className="flex gap-4 justify-end mb-4">
        <SlInput size="small" id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search By Name / Email / Mobile..">
          <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
        </SlInput>
        <SlButton
          size="small"
          variant="primary"
          onClick={() => {
            handleShow("add", {});
            setFlag("add");
          }}
        >
          Add Page Rate
        </SlButton>
      </div>
      <SlDrawer label="Add Page Rate" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose}>
        <form onSubmit={formik.handleSubmit}>
          {/* Language */}
          <div className="mb-3">
            <label className="mb-1">Language</label>
            <span className="text-red-600">*</span>
            <select
              className="form-select"
              aria-label="Select Language"
              name="language"
              onBlur={formik.handleBlur}
              value={`${formik.values.language}`}
              onChange={(e) => {
                formik.setFieldValue("language", e.target.value);
              }}
            >
              <option value="">Select Language</option>
              {langoptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {submit && formik.errors.language ? <div className="text-red-600">{formik.errors.language}</div> : null}
          </div>

          {/* Newspaper Name */}
          <div className="mb-3">
            <label className="mb-1">Newspaper Name</label>
            <span className="text-red-600">*</span>
            <select
              className="form-select"
              aria-label="Select Newsapaper Name"
              name="newspaper_name"
              onBlur={formik.handleBlur}
              value={formik.values.newspaper_name}
              onChange={(e) => {
                formik.setFieldValue("newspaper_name", e.target.value);
              }}
            >
              <option value="">Select Newsapaper Name</option>
              {newspapers.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {submit && formik.errors.newspaper_name ? <div className="text-red-600">{formik.errors.newspaper_name}</div> : null}
          </div>

          {/* Page Name */}
          {/* <div className="mb-3">
                        <label className="mb-1">Page Name</label><span className="text-red-600">*</span>
                        <select
                            className="form-select"
                            aria-label="Select Page Name"
                            name="page_name"
                            onBlur={formik.handleBlur}
                            value={formik.values.page_name}
                            onChange={(e) => {
                                formik.setFieldValue("page_name", e.target.value);
                            }}
                        >
                            <option value="">Select Page Name</option>
                            {pageOptions.map((option) => (
                                <option key={option.value} value={option.label}>
                                    {option.label}
                                </option>
                            ))}
                        </select>

                        {submit && formik.errors.page_name ? (
                            <div className="text-red-600">{formik.errors.page_name}</div>
                        ) : null}
                    </div> */}

          {/* Edition Name */}
          <div className="mb-3">
            <label className="mb-1">Edition Name</label>
            <span className="text-red-600">*</span>
            <select
              className="form-select"
              aria-label="Select Edition Name"
              name="page_name"
              onBlur={formik.handleBlur}
              value={formik.values.page_name}
              onChange={(e) => {
                formik.setFieldValue("page_name", e.target.value);
              }}
            >
              <option value="">Select Edition Name</option>
              {editions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {submit && formik.errors.page_name ? <div className="text-red-600">{formik.errors.page_name}</div> : null}
          </div>

          {/* District (Location) Multi-Select for District Edition */}
          {isDistrict && (
            <div className="mb-3">
              <label className="mb-1">District(s)</label>
              <span className="text-red-600">*</span>
              <Select
                isMulti
                options={districtOptions}
                value={selectedDistricts}
                required={isDistrict}
                onChange={(selected) => {
                  setSelectedDistricts(selected || []);
                  if (!selected || selected.length !== 1) setSelectedCluster(null);
                }}
                placeholder="Select District(s)"
                classNamePrefix="select"
              />
              {/* Add District Button
              {!showAddDistrict && (
                <button type="button" className="mt-2 text-blue-600 underline" onClick={() => setShowAddDistrict(true)}>
                  + Add District
                </button>
              )} */}

              {/* Input Field to Add New District */}
              {showAddDistrict && (
                <div className="mt-2 flex gap-2 items-center">
                  <input type="text" value={newDistrict} onChange={(e) => setNewDistrict(e.target.value)} placeholder="Enter new district" className="form-control" />
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                      if (newDistrict.trim()) {
                        const newOption = { label: newDistrict.trim(), value: newDistrict.trim() };
                        if (!districtOptions.some((opt) => opt.value === newOption.value)) {
                          setDistrictOptions((prev) => [...prev, newOption]);
                        }
                        setSelectedDistricts((prev) => [...(prev || []), newOption]);
                        setNewDistrict("");
                        setShowAddDistrict(false);
                      }
                    }}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    onClick={() => {
                      setNewDistrict("");
                      setShowAddDistrict(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}

              {submit && isDistrict && selectedDistricts.length === 0 && <div className="text-red-600">At least one district is required</div>}
            </div>
          )}
          {/* Cluster Single-Select if only 1 district selected */}
          {isDistrict && selectedDistricts.length === 1 && (
            <div className="mb-3">
              <label className="mb-1">Cluster</label>
              <Select
                isMulti={false}
                options={clusterOptions}
                value={selectedCluster}
                isLoading={clusterLoading}
                onChange={(selected) => setSelectedCluster(selected)}
                placeholder={clusterLoading ? "Loading..." : "Select Cluster"}
                classNamePrefix="select"
                isDisabled={clusterLoading}
              />
              {!showAddCluster && (
                <button type="button" className="mt-2 text-blue-600 underline" onClick={() => setShowAddCluster(true)}>
                    + Add Cluster
                </button>
              )}
              {/* Input Field to Add New Cluster */}
              {showAddCluster && (
                <div className="mt-2 flex gap-2 items-center">
                  <input type="text" value={newCluster} onChange={(e) => setNewCluster(e.target.value)} placeholder="Enter new cluster" className="form-control" />
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                      if (newCluster.trim()) {
                        const newOption = { label: newCluster.trim(), value: newCluster.trim() };
                        if (!clusterOptions.some((opt) => opt.value === newOption.value)) {
                          setClusterOptions((prev) => [...prev, newOption]);
                        }
                        setSelectedCluster(newOption);
                        setNewCluster("");
                        setShowAddCluster(false);
                      }
                    }}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    onClick={() => {
                      setNewCluster("");
                      setShowAddCluster(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Ad Format */}
          <div className="mb-3">
            <label className="mb-1">Ad Format</label>
            <span className="text-red-600">*</span>
            <select
              className="form-select"
              aria-label="Select Ad Format"
              name="ad_format"
              onBlur={formik.handleBlur}
              value={formik.values.ad_format}
              onChange={(e) => {
                formik.setFieldValue("ad_format", e.target.value);
              }}
            >
              <option value="">Select Ad Format</option>
              {AdFormatOptions.map((option) => (
                <option key={option.value} value={option.label}>
                  {option.label}
                </option>
              ))}
            </select>
            {submit && formik.errors.ad_format ? <div className="text-red-600">{formik.errors.ad_format}</div> : null}
          </div>

          {/* Page number */}
          {/* <div className="mb-3">
                        <label className="mb-1"> Page Number</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Page Number"
                            aria-label=""
                            name="page_no"
                            value={formik.values.page_no}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.page_no ? (
                            <div className="text-red-600	">{"Page Number must be numerical"}</div>
                        ) : null}
                    </div> */}

          {/* Estimated Price */}
          <div className="mb-3">
            <label className="mb-1">Estimated Price</label>
            <span className="text-red-600">*</span>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Estimated Price"
              aria-label=""
              name="estimated_value"
              value={formik.values.estimated_value}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.estimated_value ? <div className="text-red-600	">{"Estimated Price must be numerical"}</div> : null}
          </div>

          <div slot="footer">
            <SlButton type="submit" variant="primary" size="small" onClick={(e) => setSubmit(true)}>
              Submit
            </SlButton>
          </div>
        </form>
      </SlDrawer>

      <div className=" mb-4">
        <ScrollContainer>
          <table className="table table-bordered">
            <thead className="sticky top-0 ">
              <tr>
                <th>Language</th>
                <th>Newspaper Name</th>
                <th>Ad Format</th>
                <th>Page Name</th>
                {/* <th >Page Number</th> */}
                <th>District(s)</th>
                <th>Cluster</th>
                <th>Price</th>
                <th>Created Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            {data?.length && !loader ? (
              <tbody>
                {data.map((item, index) => {
                  // Format district(s) display
                  let districtDisplay = "-";
                  if (item.district) {
                    if (Array.isArray(item.district)) {
                      districtDisplay = item.district.length ? item.district.join(", ") : "-";
                    } else if (typeof item.district === "string") {
                      districtDisplay = item.district.trim()
                        ? item.district
                            .split("+")
                            .map((s) => s.trim())
                            .join(", ")
                        : "-";
                    }
                  }
                  // Format cluster display
                  let clusterDisplay = item.cluster && item.cluster.trim() ? item.cluster : "-";
                  return (
                    <tr key={item.rate_id} className="group/details hover:bg-slate-100">
                      <th scope="row">{getLanguageNameByCode(parseInt(item.language))}</th>
                      <td>{item.newspaper_name}</td>
                      <td>{item.ad_format}</td>
                      <td>{item.page_name}</td>
                      {/* <td >{item.page_no}</td> */}
                      <td>{districtDisplay}</td>
                      <td>{clusterDisplay}</td>
                      <td>{item.estimated_value}</td>
                      <td>{formatDateWithTime(item.created_on)}</td>
                      <td>
                        <div className="inline-flex gap-3">
                          <SlTooltip content="Edit Page Rate">
                            <SlIconButton
                              library="lucide"
                              name="edit"
                              onClick={() => {
                                handleShow("edit", item);
                                setFlag("edit");
                                setId(item.rate_id);
                              }}
                            ></SlIconButton>
                          </SlTooltip>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="9" />
            ) : (
              <TableLoader colspan="9" />
            )}
          </table>
        </ScrollContainer>
      </div>
      <div className="flex justify-end"> {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}</div>
    </>
  );
}

export default Pagerates;
